import moment from 'moment'
import { REPORTS, DATE_TIME_FORMATS } from '../../../../shared/constants.js'

export const setFilterData = (reportIdent, filterData, dateFilter) =>
  shouldHaveSingleDateFilter(reportIdent)
    ? setSingleDateFilter(filterData, dateFilter)
    : setDateRangeFilter(filterData, dateFilter)

const setSingleDateFilter = (filterData, dateFilter) => ({
  ...filterData,
  ...isValidDateFilter(dateFilter) && { date: setToEndOfDay(dateFilter) }
})

const setDateRangeFilter = (filterData, dateFilter) => ({
  ...filterData,
  ...isValidDateFilter(dateFilter.from) && { from: setToStartOfDay(dateFilter.from) },
  ...isValidDateFilter(dateFilter.to) && { to: setToEndOfDay(dateFilter.to) }
})

const shouldHaveSingleDateFilter = reportIdent => reportIdent === REPORTS.WORK_IN_PROGRESS
const setToStartOfDay = date => moment(date).startOf('day').toDate()
const setToEndOfDay = date => moment(date).endOf('day').toDate()

const isValidDateFilter = dateFilter =>
  moment(dateFilter, DATE_TIME_FORMATS, true).isValid() || dateFilter instanceof Date
